// A cell only offers the hover info popover when the day has a note or a picked option item.
export function shouldShowWhereaboutsInfo(dayNote?: string, optionItemLabel?: string): boolean {
  return !!dayNote || !!optionItemLabel;
}
